<mat-nav-list class="menu" (mouseenter)="isShowing = true" (mouseleave)="isShowing = false">
    <mat-list-item routerLink="/dashboard" routerLinkActive #rla1="routerLinkActive" [activated]="rla1.isActive">
        <mat-icon mat-list-icon>dashboard</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Tableau de bord</span>
        }
    </mat-list-item>

    <mat-list-item routerLink="/centrex-users" routerLinkActive #rlaUsers="routerLinkActive"
        [activated]="rlaUsers.isActive">
        <mat-icon mat-list-icon>account_circle</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Utilisateurs</span>
        }
    </mat-list-item>

    <mat-list-item routerLink="/extensions" routerLinkActive #rlaOrga="routerLinkActive" [activated]="rlaOrga.isActive">
        <mat-icon mat-list-icon>call_split</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Groupe extensions</span>
        }
    </mat-list-item>

    <mat-list-item routerLink="/redirections" routerLinkActive #rlaRedirect="routerLinkActive"
        [activated]="rlaRedirect.isActive">
        <mat-icon mat-list-icon>subdirectory_arrow_left</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Etat redirections</span>
        }
    </mat-list-item>

    <mat-list-item routerLink="/sdas" routerLinkActive #rlaClients="routerLinkActive" [activated]="rlaClients.isActive">
        <mat-icon mat-list-icon>dialpad</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Sdas</span>
        }
    </mat-list-item>

      <mat-list-item routerLink="/devices" routerLinkActive #rlaDevices="routerLinkActive" [activated]="rlaDevices.isActive">
        <mat-icon mat-list-icon>devices</mat-icon>
        @if (isExpanded || isShowing) {
        <span class="full-width">Périphériques</span>
        }
    </mat-list-item>

</mat-nav-list>